<div class="col p-0" (click)="modelForSelectLang()">
  <div class="iti__flag iti__{{ appSettings.selectedLang }} lang"></div>
</div>

<p-dialog [header]="appSettings.translate[appSettings.selectedLang]['langs']" [(visible)]="showModal" [modal]="true" [responsive]="true">
  <div class="grid" style="width: 250px; margin-bottom: 10px">
    <div class="col-12" *ngFor="let lang of appSettings.langs">
      <p-radioButton
        name="langs"
        [value]="lang.value"
        [label]="lang.label ? lang.label : 'void'"
        [(ngModel)]="preSelectedLang"
        (onClick)="changeLang()"
      ></p-radioButton>
    </div>
  </div>
</p-dialog>
